<script setup lang="ts">
const { notifications } = useNotifications();

const unreadNotifications = computed(() => {
  return (notifications.value ?? []).filter(
    (notification) => !notification.read_at,
  )?.length;
});
</script>

<template>
  <NuxtLink to="/" class="p-2">
    <PrimeOverlayBadge
      v-if="unreadNotifications > 0"
      :value="unreadNotifications"
      severity="danger"
      size="small"
    >
      <Bell class="text-white lg:text-surface-700" />
    </PrimeOverlayBadge>
    <Bell v-else class="text-white lg:text-surface-700" />
  </NuxtLink>
  <!-- <button class="p-2">
    <Bell class="text-surface-700" />
  </button> -->
</template>
